import { appConfig, guardProductionMode } from "./config";

/**
 * Fail fast at module init when a PROD bundle was built without live mode flags.
 * Historically the mock defaults in `config.ts` let a production deploy silently
 * serve fixtures (2026-06-10). Importing this from `main.tsx` turns that
 * documentation-only discipline into a hard load-time error, unless an operator
 * deliberately set `VITE_ALLOW_MOCK_BUILD=1` for an intentional mock artifact.
 */
export function assertProductionMode() {
  const decision = guardProductionMode({
    prod: import.meta.env.PROD,
    authMode: appConfig.authMode,
    dataMode: appConfig.dataMode,
    allowMock: import.meta.env.VITE_ALLOW_MOCK_BUILD === "1"
  });
  if (!decision.ok) {
    // Loud console error first so the failure is visible even if a host
    // swallows the thrown error during bootstrap.
    console.error(`[coaching-dashboard] ${decision.reason}`);
    throw new Error(decision.reason);
  }
}
